import '.bx{position:relative;}.ssr-plugin'
import '.a7{width:100%;}.ssr-plugin'
import '.fo{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.cc{align-items:flex-start;}.ssr-plugin'
import '.m{padding:2rem;}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.s{overflow:hidden;}.ssr-plugin'
import '.o{position:absolute;}.ssr-plugin'
import '.ic{top:50%;}.ssr-plugin'
import '.id{right:1rem;}.ssr-plugin'
import '.ie{transform:translateY(-50%);}.ssr-plugin'
import '.if{width:120px;}.ssr-plugin'
import '.ig{height:120px;}.ssr-plugin'
import '.ih{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.hh{z-index:1;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ii{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bx a7 fo a b g cc m co s"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="o ic id ie if ig ih a c g"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bx hh a b cc aj ii"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
